import React, { useState } from 'react';
import { KeyUri, config } from "../key";
import { Link } from 'react-router-dom';
import { toast } from "react-toastify";

const VendorRegister = () => {
  const [formData, setFormData] = useState({
    companyName: '',
    businessType: 'Individual',
    registrationNumber: '',
    gstNumber: '',
    panNumber: '',
    street: '',
    city: '',
    state: '',
    pincode: '',
    country: 'India',
    email: '',
    phone_number: '',
    password: '',
    confirmPassword: ''
  });
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const {
    companyName,
    businessType,
    registrationNumber,
    gstNumber,
    panNumber,
    street,
    city,
    state,
    pincode,
    country,
    email,
    phone_number,
    password,
    confirmPassword
  } = formData;

const onChange = (e) => {
  const { name, value } = e.target;

  let updatedValue = value;

  switch (name) {
    case "companyName":
    case "city":
    case "state":
      if (!/^[A-Za-z\s]*$/.test(value)) return;
      break;

    case "phone_number":
      updatedValue = value.replace(/\D/g, "");
      if (updatedValue.length > 10) return;
      break;

    case "pincode":
      updatedValue = value.replace(/\D/g, "");
      if (updatedValue.length > 6) return;
      break;

    case "panNumber":
      updatedValue = value.toUpperCase();
      break;

    case "gstNumber":
      updatedValue = value.toUpperCase();
      break;

    default:
      break;
  }

  setFormData({ ...formData, [name]: updatedValue });
};


  const onSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    setError(null);

    // Email validation
if (!/^\S+@\S+\.\S+$/.test(email)) {
  toast.error("Enter valid email address");
  return;
}

// Phone validation (India)
if (!/^[6-9]\d{9}$/.test(phone_number)) {
  toast.error("Enter valid 10-digit Indian mobile number");
  return;
}

// Pincode validation
if (pincode && !/^\d{6}$/.test(pincode)) {
  toast.error("Enter valid 6-digit pincode");
  return;
}

// PAN validation
if (panNumber && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(panNumber)) {
  toast.error("Invalid PAN format");
  return;
}

// GST validation (if provided)
if (gstNumber && !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{3}$/.test(gstNumber)) {
  toast.error("Invalid GST format");
  return;
}

// Password strength
if (!/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{8,}$/.test(password)) {
  toast.error("Password must be 8+ chars, include uppercase, lowercase & number");
  return;
}


    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    const vendorPayload = {
      companyName,
      businessType,
      registrationNumber,
      gstNumber,
      panNumber,
      address: {
        street,
        city,
        state,
        pincode,
        country
      },
      email,
      phone_number,
      password
    };

    try {
      const res = await fetch(KeyUri.BACKEND_URI + '/vendor/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(vendorPayload)
      });

      const data = await res.json();

      if (res.ok) {
        toast.success("Registration successful! Please login.");
        setFormData({
          companyName: '',
          businessType: 'Individual',
          registrationNumber: '',
          gstNumber: '',
          panNumber: '',
          street: '',
          city: '',
          state: '',
          pincode: '',
          country: 'India',
          email: '',
          phone_number: '',
          password: '',
          confirmPassword: ''
        });
      } else {
        toast.error(data.message || "Registration failed");
      }
    } catch (err) {
       toast.error("Server error. Please try again later.");
    }
  };

  return (
    <div className="max-w-3xl mx-auto p-6 bg-white rounded shadow-md my-16 lg:my-40">
      <h2 className="text-3xl font-semibold mb-6 text-center text-gray-800">Vendor Registration</h2>

    
      <form onSubmit={onSubmit} className="space-y-6">

        <div>
          <label className="block mb-1 font-medium text-gray-700" htmlFor="companyName">Company Name / Business Name</label>
          <input
            className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-indigo-500"
            type="text"
            id="companyName"
            name="companyName"
            placeholder="Company Name / Business Name"
            value={companyName}
            onChange={onChange}
            required
          />
        </div>

        <div>
          <label className="block mb-1 font-medium text-gray-700" htmlFor="businessType">Business Type</label>
          <select
            id="businessType"
            name="businessType"
            value={businessType}
            onChange={onChange}
            className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-indigo-500"
          >
            <option value="Individual">Individual</option>
            <option value="Company">Company</option>
            <option value="Partnership">Partnership</option>
            <option value="LLP">LLP</option>
          </select>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block mb-1 font-medium text-gray-700" htmlFor="registrationNumber">Registration Number</label>
            <input
              type="text"
              id="registrationNumber"
              name="registrationNumber"
              placeholder="Registration Number"
              value={registrationNumber}
              onChange={onChange}
              className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div>
          <div>
            <label className="block mb-1 font-medium text-gray-700" htmlFor="gstNumber">GST Number</label>
            <input
              type="text"
              id="gstNumber"
              name="gstNumber"
              placeholder="GST Number"
              value={gstNumber}
              onChange={onChange}
              className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div>
          <div>
            <label className="block mb-1 font-medium text-gray-700" htmlFor="panNumber">PAN Number</label>
            <input
              type="text"
              id="panNumber"
              name="panNumber"
               maxLength="10"
              placeholder="PAN Number"
              value={panNumber}
              onChange={onChange}
              className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div>
        </div>

        <fieldset className="border p-4 rounded border-gray-300">
          <legend className="font-semibold text-gray-700 mb-2">Address</legend>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block mb-1 font-medium text-gray-700" htmlFor="street">Street</label>
              <input
                type="text"
                id="street"
                name="street"
                placeholder="Street Address"
                value={street}
                onChange={onChange}
                className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
            </div>
            <div>
              <label className="block mb-1 font-medium text-gray-700" htmlFor="city">City</label>
              <input
                type="text"
                id="city"
                name="city"
                placeholder="City"
                value={city}
                onChange={onChange}
                className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
            </div>
            <div>
              <label className="block mb-1 font-medium text-gray-700" htmlFor="state">State</label>
              <input
                type="text"
                id="state"
                name="state"
                placeholder="State"
                value={state}
                onChange={onChange}
                className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
            </div>
            <div>
              <label className="block mb-1 font-medium text-gray-700" htmlFor="pincode">Pincode</label>
              <input
                type="text"
                id="pincode"
                name="pincode"
                inputMode="numeric"
                placeholder="Pincode"
                value={pincode}
                onChange={onChange}
                className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
            </div>
            <div>
              <label className="block mb-1 font-medium text-gray-700" htmlFor="country">Country</label>
              <input
                type="text"
                id="country"
                name="country"
                placeholder="Country"
                value={country}
                onChange={onChange}
                disabled
                className="w-full px-4 py-2 bg-gray-100 rounded border border-gray-300 cursor-not-allowed"
              />
            </div>
          </div>
        </fieldset>

        <div>
          <label className="block mb-1 font-medium text-gray-700" htmlFor="email">Email Address</label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Email Address"
            value={email}
            onChange={onChange}
            required
            className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />
        </div>

        <div>
          <label className="block mb-1 font-medium text-gray-700" htmlFor="phone_number">Phone Number</label>
          <input
            type="tel"
            id="phone_number"
            name="phone_number"
            inputMode="numeric"
            placeholder="Phone Number"
            value={phone_number}
            onChange={onChange}
            required
            className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
  <label className="block mb-1 font-medium text-gray-700" htmlFor="password">
    Password
  </label>

  <div className="relative">
    <input
      type={showPassword ? "text" : "password"}
      id="password"
      name="password"
      placeholder="Password"
      value={password}
      onChange={onChange}
      required
      className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-indigo-500 pr-10"
    />

    <button
      type="button"
      onClick={() => setShowPassword(!showPassword)}
      className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
    >
      {showPassword ? (
        
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M13.875 18.825A10.05 10.05 0 0112 19c-5 0-9-4-10-7 1-3 4-7 10-7 1.063 0 2.087.153 3.05.437M15 12a3 3 0 11-6 0 3 3 0 016 0zm6 0c-.5 1.5-2 3.5-4 5M3 3l18 18" />
        </svg>
      ) : (
       
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M15 12a3 3 0 11-6 0 3 3 0 016 0zm6 0c-1 3-4 7-10 7S2 15 1 12c1-3 4-7 10-7s9 4 10 7z" />
        </svg>
      )}
    </button>
  </div>
</div>

       <div>
  <label className="block mb-1 font-medium text-gray-700" htmlFor="confirmPassword">
    Confirm Password
  </label>

  <div className="relative">
    <input
      type={showConfirmPassword ? "text" : "password"}
      id="confirmPassword"
      name="confirmPassword"
      placeholder="Confirm Password"
      value={confirmPassword}
      onChange={onChange}
      required
      className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-indigo-500 pr-10"
    />

    <button
      type="button"
      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
      className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
    >
      {showConfirmPassword ? (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M13.875 18.825A10.05 10.05 0 0112 19c-5 0-9-4-10-7 1-3 4-7 10-7 1.063 0 2.087.153 3.05.437M15 12a3 3 0 11-6 0 3 3 0 016 0zm6 0c-.5 1.5-2 3.5-4 5M3 3l18 18" />
        </svg>
      ) : (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M15 12a3 3 0 11-6 0 3 3 0 016 0zm6 0c-1 3-4 7-10 7S2 15 1 12c1-3 4-7 10-7s9 4 10 7z" />
        </svg>
      )}
    </button>
  </div>
</div>

        </div>

        <button
          type="submit"
          className="w-full py-3 bg-indigo-600 hover:bg-indigo-700 transition text-white font-semibold rounded"
        >
          Register
        </button>
        <p className="mt-4 text-center text-gray-600">
  Already have an account?{' '}
  <Link to="/vendor/login" className="text-indigo-600 hover:underline">
    Login
  </Link>
</p>
      </form>
    </div>
  );
};

export default VendorRegister;
